import classNames from 'classnames'
import {useMemo} from 'react'

import type {ProblemOccurrenceId} from '../../../../../types'
import BuildProblemInvestigations from '../../../../common/Investigations/BuildProblemInvestigations'
import ProblemMutes from '../../../../common/Mutes/ProblemMutes'
import BuildProblemInvestigationHistoryPopup from '../../../InvestigationHistory/InvestigationHistoryPopup/BuildProblemInvestigationHistoryPopup.container'
import {getProblemOccurrencesById} from '../../BuildProblems.selectors'

import BuildProblemActions from './BuildProblemActions/BuildProblemActions.container'

import styles from './BuildProblemsTreeLeaf.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  problemOccurrenceId: ProblemOccurrenceId
}

function BuildProblemsTreeLeaf({problemOccurrenceId}: Props) {
  const problemOccurrence = useAppSelector(state =>
    getProblemOccurrencesById(state, problemOccurrenceId),
  )
  const {details, newFailure, build} = problemOccurrence ?? {}
  const buildId = build?.id

  const renderRow = useMemo(
    () => (
      <span className={styles.comment} title={details}>
        {details}
      </span>
    ),
    [details],
  )

  return (
    <div className={classNames(styles.row, {[styles.new]: newFailure})}>
      <ProblemMutes
        className={styles.problemMutes}
        iconClassName={styles.problemMutesIcon}
        buildId={buildId}
        problemOccurrenceId={problemOccurrenceId}
      />
      <BuildProblemInvestigations
        className={styles.problemInvestigations}
        iconClassName={styles.problemInvestigationsIcon}
        buildId={buildId}
        problemOccurrenceId={problemOccurrenceId}
        isShowOnlyIcon
      />
      <div className={styles.content}>{renderRow}</div>
      <BuildProblemActions className={styles.actions} problemOccurrence={problemOccurrence} />
      <BuildProblemInvestigationHistoryPopup
        buildId={buildId}
        problemOccurrenceId={problemOccurrenceId}
      />
    </div>
  )
}

export default BuildProblemsTreeLeaf
